export const selectTeams = (state) => state.teams;
